import { CoreInitiativesBulkName } from './name';
import { coreInitiativesGetAsyncSlice } from '../get';
import { createDeleteAsyncSlice } from '@sonar-software/xuder';
import { deleteInitiativesBulk } from '@api';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';

export const coreInitiativesBulkDeleteAsyncSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [
			() =>
				coreInitiativesGetAsyncSlice.asyncActionCreators.repeatGetCoreInitiatives((previous) => ({
					...previous,
					key: '',
					paginationDirection: PaginationDirection.Forward
				}))
		]
	},
	name: CoreInitiativesBulkName,
	receive: false,
	request: true,
	requestHandler: deleteInitiativesBulk
});
